export class FileDataRequest {
  constructor ({ userId = 0, after = -1, before = -1 } = {}) {
    this.userId = userId
    this.after = after
    this.before = before
  }
}
